import Poster from '../poster/poster';
import posterContent from '../../data/content';

const Home = () => (
  <div className="c-home">
    <div className="c-home--welcome">
      <p className="c-home--welcome__title">Welcome to our family-run takeaway</p>
      <hr className="c-home--welcome__seperator" />
      <p className="c-home--welcome__text">Here at JK's, we pride ourselves by using only the finest and freshest ingredients. We strive to create dishes which are distinctive and satisfying to suit both our loyal and new customers. We're constantly trying out new ideas in our kitchen and we'd love to find out what you think.</p>
    </div>
    {posterContent.map((body, i) =>
      <div className="c-home--container">
        <Poster key={i} caption={body.caption} subCaption={body.subCaption} link={body.link} image={body.image} />
      </div>
    )}
  </div>
);

export default Home;
